import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { BUTTON_WIDTH } from 'src/config/styles'
import { iconContainerStyles } from '@components/Clinic/clinic.styles'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: BUTTON_WIDTH,
    margin: [40, 'auto', 0, 'auto'],
    padding: [0, 16],
  },
  informationContainer: {
    display: 'flex',
    marginBottom: 24,
    width: 314,
    alignItems: 'flex-start',
  },
  iconContainer: iconContainerStyles,
  eventIcon: { color: theme.palette.primary['600'], width: 48, height: 48, marginRight: 16 },
  infoDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    ...typography['Lato Emphasized 1'],
    marginBottom: 6,
  },
  description: {
    ...typography['Lato Body 2'],
    marginBottom: 6,
  },
  buttonContainer: {
    marginTop: 48,
    width: '100%',
  },
  blockBreak: {
    borderBottom: '1px solid #C4C4C4',
    paddingBottom: 12,
    marginBottom: 12,
  },
  gapFillerAppointmentBlock: {
    marginBottom: 48,
  },
}))
